import { PlatformDataHydrator } from '@iphoneps/events';
import { v1 as uuid } from 'uuid';

export default new PlatformDataHydrator({
    platform: window.App.isIosPwa && window.App.isIosView ? 'camguru-app' : 'sales',
    resolveAnonymousIdFn: () => {
        if (window.App.ipse_aid) {
            return window.App.ipse_aid;
        }

        if (window.ipse_aid) {
            return window.ipse_aid;
        }

        const aid = uuid();
        window.ipse_aid = aid;

        return aid;
    },
    resolveSessionIdFn: () => window.App.sessionId,
    resolveContactIdFn: () => window.App.contact?.ips_id,
    resolveProductDataFn: () => {
        return window.App.product
            ? {
                  slug: window.App.product?.slug,
                  price: window.App.product?.price?.full?.value,
                  discount: window.App.product?.percentage,
                  currency: window.App.product?.price?.currency,
              }
            : undefined;
    },
    resolveSplitTestDataFn: () => {
        const data = window.App.split_test_data ?? {};

        if (Object.keys(data).length === 0) {
            return null;
        }

        return data;
    },
});
